import React, { useMemo, useState } from "react";
import { Container, Typography, Paper, TextField, Button, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import apiService from "../../utils/api";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const urlEmail = searchParams.get("email") || "";
  const urlToken = searchParams.get("token") || "";
  const hasUrlCredentials = useMemo(() => Boolean(urlEmail && urlToken), [urlEmail, urlToken]);

  const [email, setEmail] = useState(urlEmail);
  const [token, setToken] = useState(urlToken);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== passwordConfirm) {
      setError("Passwords do not match");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiService.resetPassword(token, password, email);
      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (err) {
      const message = err?.response?.data?.error || "Could not reset password. The link may have expired.";
      console.error("Error resetting password:", message);
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography mt={2} variant="h4" gutterBottom style={{ textAlign: "center" }}>
        Change Password
      </Typography>
      <Paper elevation={3} sx={{ padding: 2 }}>
        {success ? (
          <Typography variant="body1" style={{ color: "green" }}>
            Password reset successful! You can now login with your new password.
          </Typography>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <Typography variant="body1" style={{ color: "red" }}>
                {error}
              </Typography>
            )}

            {hasUrlCredentials ? (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Resetting password for <strong>{email}</strong>.
              </Typography>
            ) : (
              <>
                <TextField
                  type="email"
                  label="Email"
                  fullWidth
                  required
                  margin="dense"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                  type="text"
                  label="Reset Code"
                  fullWidth
                  required
                  margin="dense"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  helperText="Paste the code from your password reset email."
                />
              </>
            )}

            <TextField
              type="password"
              label="New Password"
              fullWidth
              required
              margin="dense"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              type="password"
              label="Confirm Password"
              fullWidth
              required
              margin="dense"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
            <Box mt={2}>
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                {isSubmitting ? "Resetting…" : "Reset Password"}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Container>
  );
};

export default ResetPassword;
